/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIFeedbackSubmission } from './APIFeedbackSubmission';
import {
    APIFeedbackSubmissionFromJSON,
    APIFeedbackSubmissionFromJSONTyped,
    APIFeedbackSubmissionToJSON,
} from './APIFeedbackSubmission';

/**
 * 
 * @export
 * @interface APIPaginatedFeedbackSubmissionList
 */
export interface APIPaginatedFeedbackSubmissionList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedFeedbackSubmissionList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedFeedbackSubmissionList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedFeedbackSubmissionList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIFeedbackSubmission>}
     * @memberof APIPaginatedFeedbackSubmissionList
     */
    results: Array<APIFeedbackSubmission>;
}

/**
 * Check if a given object implements the APIPaginatedFeedbackSubmissionList interface.
 */
export function instanceOfAPIPaginatedFeedbackSubmissionList(value: object): value is APIPaginatedFeedbackSubmissionList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedFeedbackSubmissionListFromJSON(json: any): APIPaginatedFeedbackSubmissionList {
    return APIPaginatedFeedbackSubmissionListFromJSONTyped(json, false);
}

export function APIPaginatedFeedbackSubmissionListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedFeedbackSubmissionList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIFeedbackSubmissionFromJSON)),
    };
}

export function APIPaginatedFeedbackSubmissionListToJSON(value?: APIPaginatedFeedbackSubmissionList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIFeedbackSubmissionToJSON)),
    };
}

